// src/components/ResetPassword.js
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import './PasswordReset.css';

const PasswordReset = () => {
    const [passwords, setPasswords] = useState({
        new_password: '',
        confirm_password: ''
    });
    const [loading, setLoading] = useState(false);
    const { uid, token } = useParams();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setPasswords({
            ...passwords,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (passwords.new_password !== passwords.confirm_password) {
            Swal.fire({
                icon: 'error',
                title: 'Password Mismatch',
                text: 'The passwords you entered do not match. Please try again.',
                confirmButtonColor: '#1e3a8a'
            });
            return;
        }

        // Password validation
        if (passwords.new_password.length < 8) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Password',
                text: 'Password must be at least 8 characters long.',
                confirmButtonColor: '#1e3a8a'
            });
            return;
        }

        setLoading(true);

        try {
            await axios.post('https://api.burrayhr.com/api/reset-password/', {
                uid: uid,
                token: token,
                new_password: passwords.new_password,
                confirm_password: passwords.confirm_password
            });

            await Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Your password has been reset successfully.',
                timer: 2000,
                showConfirmButton: false,
                willClose: () => {
                    navigate('/');
                }
            });

        } catch (error) {
            console.error('Password reset error:', error);
            
            let errorMessage = 'Something went wrong. Please try again.';
            
            if (error.response?.data?.error) {
                errorMessage = error.response.data.error;
            } else if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.response?.data?.non_field_errors) {
                errorMessage = error.response.data.non_field_errors[0];
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage,
                confirmButtonColor: '#1e3a8a'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="reset-password-container">
            <div className="reset-password-form">
                <div className="logo-container">
                    <img src='/burray.png' alt='burrayhr' className="logo" />
                </div>
                <h2>Reset Password</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>New Password</label>
                        <input
                            type="password"
                            name="new_password"
                            value={passwords.new_password}
                            onChange={handleChange}
                            required
                            minLength="8"
                            placeholder="Enter new password"
                            className="form-input"
                        />
                    </div>
                    <div className="form-group">
                        <label>Confirm Password</label>
                        <input
                            type="password"
                            name="confirm_password"
                            value={passwords.confirm_password}
                            onChange={handleChange}
                            required
                            minLength="8"
                            placeholder="Confirm new password"
                            className="form-input"
                        />
                    </div>
                    <button 
                        type="submit" 
                        className="reset-button"
                        disabled={loading}
                    >
                        {loading ? 'Resetting Password...' : 'Reset Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PasswordReset;